export function startsWithVowel(input: string): boolean {
	return /[aeiou]/.test(input.toLowerCase().charAt(0))
}
